/**
 * @flow
 * @relayHash 5c518afc820b41d59cfe1cdb2807f676
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type FormType = "ITEM" | "JOB_STEP" | "JOB_TASK" | "JOB_YIELD";
export type UpdateFormInput = {|
  id: string,
  name?: ?string,
  description?: ?string,
|};
export type UpdateFormMutationVariables = {|
  input: UpdateFormInput
|};
export type UpdateFormMutationResponse = {|
  +updateForm: {|
    +formEdge: {|
      +node: {|
        +id: string,
        +name: string,
        +description: ?string,
        +type: FormType,
      |}
    |}
  |}
|};
export type UpdateFormMutation = {|
  variables: UpdateFormMutationVariables,
  response: UpdateFormMutationResponse,
|};
*/


/*
mutation UpdateFormMutation(
  $input: UpdateFormInput!
) {
  updateForm(input: $input) {
    formEdge {
      node {
        id
        name
        description
        type
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateFormInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateForm",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateFormPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "formEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "FormEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Form",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "type",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateFormMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateFormMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateFormMutation",
    "id": null,
    "text": "mutation UpdateFormMutation(\n  $input: UpdateFormInput!\n) {\n  updateForm(input: $input) {\n    formEdge {\n      node {\n        id\n        name\n        description\n        type\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c65556f2aa3a685f8f44026b68c74ff3';
module.exports = node;
